import { get, post } from "../axios";
import { responseIsSuccessful } from "../global-helpers";
import { formatProjectOrContractObject, simpleResponse } from "./api-helpers";
import { Task } from "../models/Task";
import { Procurement } from "../models/Procurement";
import { WorkOrder } from "../models/WorkOrder";
import { Contract } from "../models/Contract";

function generateQueryParams(startDate, endDate) {
  return `?start_date=${startDate}&end_date=${endDate}`;
}

async function procurementsResponse(url) {
  return await get(url, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.procurements) {
        return res.data.procurements.map(p => {
          formatProjectOrContractObject(p.contract);
          return new Procurement(p);
        });
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

async function tasksResponse(url, isSingleDayQuery = false) {
  return await get(url, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.tasks) {
        let tasks = [];
        res.data.tasks.forEach(t => {
          if (t.path === "scope_items" && t.work_scope_item) {
            t.name = `${t.work_scope_item.name} (${t.work_scope_item.all_tasks})`;
            t.id = t.work_scope_item.id;
            t.status = t.is_completed ? "completed" : "not-started";
          }

          if (t.contract) {
            formatProjectOrContractObject(t.contract);
          }

          if (t.schedules && t.schedules.length > 0 && !isSingleDayQuery) {
            t.schedules.forEach(s => {
              let taskClone = Object.assign({}, t);
              taskClone.scheduled_for = s.scheduled_for;
              tasks.push(new Task(taskClone));
            });
          }

          tasks.push(new Task(t));
        });

        return tasks;
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

async function weeklyCrewViewResponse(url) {
  return await get(url, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.crews) {
        return res.data.crews.map(i => {
          if (i.work_scope_items) {
            i.work_scope_items = i.work_scope_items.map(wsi => {
              if (wsi.contract) {
                formatProjectOrContractObject(wsi.contract);
                wsi.contract = new Contract(wsi.contract);
              }
              return wsi;
            });
          }

          if (i.tasks) {
            i.tasks = i.tasks.map(task => {
              if (task.contract) {
                formatProjectOrContractObject(task.contract);
                task.contract = new Contract(task.contract);
              }
              return task;
            });
          }

          if (i.scheduled_procurements) {
            i.scheduled_procurements = i.scheduled_procurements.map(proc => {
              if (proc.contract) {
                formatProjectOrContractObject(proc.contract);
                proc.contract = new Contract(proc.contract);
              }
              return proc;
            });
          }

          return i;
        });
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function getCrewsScheduled(startDate, endDate) {
  const queryParams = generateQueryParams(startDate, endDate);
  return tasksResponse(`dashboard/crews-scheduled/${queryParams}`);
}

export async function getCrewsScheduledWeekly(startDate, endDate) {
  const queryParams = generateQueryParams(startDate, endDate);
  return weeklyCrewViewResponse(
    `dashboard/crews-scheduled-admin/${queryParams}`
  );
}

export async function getScheduledDeliveries(startDate, endDate) {
  const queryParams = generateQueryParams(startDate, endDate);
  return procurementsResponse(`dashboard/scheduled-deliveries/${queryParams}`);
}

export async function getDeliveredProcurements(startDate, endDate) {
  const queryParams = generateQueryParams(startDate, endDate);
  return procurementsResponse(
    `dashboard/delivered-procurements/${queryParams}`
  );
}

export async function getOnHoldDeliveries(startDate, endDate) {
  const queryParams = generateQueryParams(startDate, endDate);
  return procurementsResponse(`dashboard/on-hold-deliveries/${queryParams}`);
}

export async function getCancelledDeliveries(startDate, endDate) {
  const queryParams = generateQueryParams(startDate, endDate);
  return procurementsResponse(`dashboard/cancelled-deliveries/${queryParams}`);
}

export async function getMyTasks(startDate, endDate) {
  const queryParams = generateQueryParams(startDate, endDate);
  return tasksResponse(
    `dashboard/my-tasks/${queryParams}`,
    startDate === endDate
  );
}

export async function getWorkOrders(startDate, endDate) {
  const queryParams = generateQueryParams(startDate, endDate);
  return get(
    `dashboard/my-work-orders/${queryParams}`,
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res) && res.data.work_orders) {
        return res.data.work_orders.map(wo => {
          if (wo.contract) {
            formatProjectOrContractObject(wo.contract);
          }

          return new WorkOrder(wo);
        });
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function addCrewAssignment(formParams) {
  return await simpleResponse(
    post(
      "dashboard/add-crew-assignment",
      { crew_schedule_params: formParams },
      window.localStorage.apiToken
    )
  );
}
